<h2 mat-dialog-title>Select Suites To Add</h2>

<form [formGroup]="form" (ngSubmit)="save()">
  <mat-dialog-content class="space-y">
    <div class="checkbox-grid" role="group" [attr.aria-label]="data.title">
      @for (ctrl of boxes.controls; track ctrl; let i = $index) {
        <label class="row">
          <mat-checkbox [formControl]="ctrl">{{ suites()[i]['name'] }}</mat-checkbox>
        </label>
      }
    </div>

    @if (selectedCount() === 0) {
      <div class="error">Pick at least one option to continue.</div>
    }
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button type="button" mat-button (click)="cancel()">Cancel</button>
    <button type="submit" mat-flat-button color="primary" [disabled]="selectedCount() === 0">
      Save
    </button>
  </mat-dialog-actions>
</form>
